import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import moment from 'moment';
import {Card, Loader, Table, Popup, Icon} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {formsSections, ftrStatus} from '../../../common/constants/ftr';
import {dateFormatShow} from '../../../common/constants/datesFormat';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';

class EnteredFtr extends Component {
  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.FormsManage, scopes.Edit)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchEnteredAnswersList('FTR,RSR');
  }

  renderLoaderOrForms() {
    const {loading} = this.props;
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan="100%">
            <Loader active inline="centered" />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderEnteredForms();
  }

  renderEnteredForms() {
    const {enteredAnswersList} = this.props;
    if (!enteredAnswersList.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign="center" colSpan={7}>
            No hay formularios ingresados
          </Table.Cell>
        </Table.Row>
      );
    }

    return enteredAnswersList.map((element, index) => {
      const answerId = element._id.$oid;
      const dateFormatted = moment(element.createdDate).format(dateFormatShow);

      const answers = element.answers;
      const title = answers && answers.title ? answers.title : '';

      return (
        <Table.Row key={index}>
          <Table.Cell textAlign="center">{element.formNumber}</Table.Cell>
          <Table.Cell textAlign="center">{element.type}</Table.Cell>
          <Table.Cell textAlign="center">{formsSections[element.section].name}</Table.Cell>
          <Table.Cell textAlign="center">{title}</Table.Cell>
          <Table.Cell textAlign="center">{ftrStatus[element.status]}</Table.Cell>
          <Table.Cell textAlign="center">{dateFormatted}</Table.Cell>
          <Table.Cell textAlign="center">
            <Popup
              trigger={
                <Link to={`/formulario/${answerId}/ver`}>
                  <Icon name="eye" size="large" />
                </Link>
              }
              content="Ver"
              position="top center"
              inverted
            />
            <Popup
              trigger={
                <Link to={`/formulario/${answerId}/editar`}>
                  <Icon name="write" size="large" />
                </Link>
              }
              content="Editar"
              position="top center"
              inverted
            />
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    return (
      <div className="entered-ftr-list">
        <Card raised fluid>
          <div className="title-bar">
            <div className="title">
              <h2>Formularios ingresados</h2>
            </div>
          </div>
        </Card>

        <Card fluid raised>
          <Table striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign="center">Número de Formulario</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Tipo</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Sección</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Título</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Estado</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Fecha</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Acciones</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>{this.renderLoaderOrForms()}</Table.Body>
          </Table>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.enteredFTR.loading,
    'enteredAnswersList': state.enteredFTR.list,
    'permissions': state.session.permissions,
  };
};

const {fetchEnteredAnswersList, navigateTo} = Actions;

export default connect(mapStateToProps, {
  fetchEnteredAnswersList,
  navigateTo,
})(EnteredFtr);
